import React, { Component } from "react";
import Table from "./../common/table";
import { Link, withRouter } from "react-router-dom";
import moment from "moment"

class CompaniesTable extends Component {
	// constructor(props) {
	// 	super(props);
	// 	this.state = {
	// 		values: [],
	// 	};
	// }

	columns = [
		//   {path: '_id', label: 'Id'},
		{
			key: "checkbox",
			label: (
				<input
					type="check"
					style={{
						width: "15px",
						height: "15px",
						marginTop: "0.4rem",
						borderRadius: 0,
					}}
				/>
			),
			content: (company) => (
				<span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
					<input
						type="checkbox"
						style={{
							width: "15px",
							height: "15px",
							marginTop: "0.4rem",
							borderRadius: 0,
						}}
						onChange={this.props.handleCheckboxChange}
						value={company._id}
					/>
				</span>
			),
		},
		{
		  label: "Username",
		  path: "companies.username",
		  content: (user) => (
			<span className="icon-img sm-r-5">
			  <img
				style={{ width: "20px", height: "20px", borderRadius: "50%" }}
				src={user?.companies?.imageSrc}
				alt=""
			  />{" "}
			  {user?.companies?.username}
			</span>
		  ),
		},
		{label: 'Email',   path: 'companies.email' } ,  
		{label: 'Business-Name',   path: 'companyInfo.businessName' } ,       
		{label: 'Firstname',   path: 'companies.contactName.first' } ,   
		{label: 'initials',   path: 'companies.contactName.initials' } ,   	  
		{label: 'Lastname',   path: 'companies.contactName.last' } ,   	  
//		{label: 'DOB',   path: 'companies.dateBirth' ,content:(user) =>(moment(user.companies.dateBirth).format("L"))} ,   	  
		{label: 'Gender',   path: 'companies.gender' } ,   	  
		{label: 'Address 1',   path: 'companies.Address.address1' } ,   
		{label: 'Address 2',   path: 'companies.Address.address2' } ,   
		{label: 'Address 3',   path: 'companies.Address.address3' } ,           
		{label: 'Zip',   path: 'companies.Address.zip' } ,   	  
		{label: 'City',   path: 'companies.Address.city' } ,   	      
		{label: 'State',   path: 'companies.Address.state' } ,   	          
		{label: 'Country',   path: 'companies.Address.country' } ,   	  	  
		{label: 'Website',   path: 'companies.website' } ,   
		{label: 'Linkedin',   path: 'companies.linkedin.profileUrl' } ,       
		{label: 'Mobile',   path: 'companies.phones.mobile' } ,   	  
		{label: 'Phone',   path: 'companies.phones.phone' } ,   	  
		{label: 'Skype',   path: 'companies.phones.skype' } , 
		{label: 'IBAN',   path: 'bankInfo.IBAN' } ,   
		{label: 'Bank',   path: 'bankInfo.bank' } ,   
		{label: 'Branch Bank',   path: 'bankInfo.branchOfBank' } ,   
		{label: 'Subscription',   path: 'subscription.subscription' } ,   	  
		{label: 'SubscriptionStartDate',   path: 'subscription.subscriptionStartDate' } ,   	  
		{label: 'SubscriptionPeriod',   path: 'subscription.subscriptionPeriod' } ,   	  		
		{label: 'HIPIO No',   path: 'healthcareProviderIdentifierOrganisation' } ,   	  
		{label: 'HIPII No',   path: 'healthcareProviderIdentifierIndividual' } ,   	  
		{label: 'ChamberCommerce No',   path: 'chamberCommerceNo' } ,   
		{label: 'TaxPayerNo',   path: 'taxPayerNo' } ,   
		{label: 'treatments',   path: 'treatments' } ,   
		{label: 'LicenseNo',   path: 'licenseNo' } ,   	  
		{label: 'License Valid Till',   path: 'licenseValidTill' } ,   	      
		{label: 'Branch',   path: 'branch' } ,   
		{label: 'Sub-Branch',   path: 'subBranch' } ,   		
		{label: 'OrganizationA Name',   path: 'organizationAName' } ,   	          
		{label: 'OrganizationA Member No',   path: 'organizationAMemberNo' } ,   	  	  
		{label: 'OrganizationB Name',   path: 'organizationBName' } ,   	          
		{label: 'OrganizationB Member No',   path: 'organizationBMemberNo' } ,   	  	  
		{label: 'Status',   path: 'status' } ,   	  	  		
	];

	render() {
		//console.log(this.columns) ;
		const { users, onSort, sortColumn } = this.props;
		return (
			<Table
				columns={this.columns}
				sortColumn={sortColumn}
				onSort={onSort}
				data={users}
			/>
		);
	}
}

export default CompaniesTable;

